<template>
    <div class="p-5 darker">
        <div class="col-md-12 text-right mb-4 px-0">
            <input type="submit" value="Save" class="btn widest ml-auto" @click="save" :disabled="!hasUnsavedChanges">
        </div>

        <!-- Accodion ID 1 - Check-in | Disable -->
        <div v-if="accordions[0].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(0)">
            <span class="darker font-weight-600">Check-in</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[0].isOpen}"></i>
        </div>
        <div v-if="accordions[0].isOpen && accordions[0].enabled" class="row mb-4">
            <div class="col-md-4 mb-2">
                <label class="full">
                    Location to check-in
                    <input type="text" class="bg-lighter" v-model="localPresets.location.name">
                </label>
            </div>

            <div class="col-md-3 mb-2">
                <label class="full">
                    Latitude
                    <input type="text" class="bg-lighter" v-model="localPresets.location.latitude">
                </label>
            </div>

            <div class="col-md-3 mb-2">
                <label class="full">
                    Longitude
                    <input type="text" class="bg-lighter" v-model="localPresets.location.longitude">
                </label>
            </div>
        </div>

         <!-- Accodion ID 2 - Agent Sales - Payment and Deposit | Enable -->
         <div v-if="accordions[1].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(1)">
            <span class="darker font-weight-600">Agent Sales - Payment and Deposit</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[1].isOpen}"></i>
        </div>
        <div v-if="accordions[1].isOpen && accordions[1].enabled" class="mb-4">
            <div class="row mb-4">
                <div class="col-md-6">
                    <label class="full">
                        Payment
                    </label>
                    <v-select v-model="agentsPaymentDepositType" :options="getRequirePaymentOptions"  @input="setAgentPaymentDepositType" label="description"></v-select>
                </div>

                <div class="col-md-4" v-if="localPresets.agentsPaymentDepositType && localPresets.agentsPaymentDepositType == 2">
                    <label class="full">
                        Deposit
                    </label>
                    <v-select v-model="agentsDepositType" :options="getDepositOptions" @input="setAgentDepositType" label="description"></v-select>
                    <span class="fs-smaller dark">This is the deposit that the customer must pay at the time of booking.</span>
                </div>

                <div class="col-md-2 mb-2 d-flex justify-content-end" v-if="localPresets.agentsPaymentDepositType && localPresets.agentsPaymentDepositType == 2 && agentsDepositType && agentsDepositType.id != 2">
                    <label class="full">
                        Amount
                        <div class="d-flex">
                            <input class="glued-right bg-lighter" type="number" v-model.number="localPresets.agentsDepositValue">
                            <div class="glued-left glued-left-min-width" v-if="localPresets.agentsDepositType == 0">€</div>
                            <div class="glued-left glued-left-min-width" v-if="localPresets.agentsDepositType == 1">%</div>
                        </div>
                    </label>
                </div>
            </div>
        </div>

        <!-- Accodion ID 3 - Direct Sales - Payment and Deposit | Enable -->
        <div v-if="accordions[2].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(2)">
            <span class="darker font-weight-600">Direct Sales - Payment and Deposit</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[2].isOpen}"></i>
        </div>
        <div v-if="accordions[2].isOpen && accordions[2].enabled" class="mb-4">
            <div class="row mb-4">
                <div class="col-md-6">
                    <label class="full">
                        Payment
                    </label>
                    <v-select v-model="paymentDepositType" :options="getRequirePaymentOptions"  @input="setPaymentDepositType" label="description"></v-select>
                </div>

                <div class="col-md-4" v-if="localPresets.paymentDepositType && localPresets.paymentDepositType == 2">
                    <label class="full">
                        Deposit
                    </label>
                    <v-select v-model="depositType" :options="getDepositOptions" @input="setDepositType" label="description"></v-select>
                    <span class="fs-smaller dark">This is the deposit that the customer must pay at the time of booking.</span>
                </div>

                <div class="col-md-2 mb-2 d-flex justify-content-end" v-if="localPresets.paymentDepositType && localPresets.paymentDepositType == 2 && depositType && depositType.id != 2">
                    <label class="full">
                        Amount
                        <div class="d-flex">
                            <input class="glued-right bg-lighter" type="number" v-model.number="localPresets.depositValue">
                            <div class="glued-left glued-left-min-width" v-if="localPresets.depositType == 0">€</div>
                            <div class="glued-left glued-left-min-width" v-if="localPresets.depositType == 1">%</div>
                        </div>
                    </label>
                </div>

                <div class="col-md-6">
                    <label class="full">
                        Default cancel payment type
                    </label>
                    <v-select v-model="paymentCancelTypeObject" :options="paymentCancelTypeOptions"  @input="setPaymentCancelType" label="name"></v-select>
                </div>
            </div>
        </div>

        <!-- Accodion ID 4 - Cancellation rules | Disable -->
        <div v-if="accordions[3].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(3)">
            <span class="darker font-weight-600">Cancellation rules</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[3].isOpen}"></i>
        </div>
        <div v-if="accordions[3].isOpen && accordions[3].enabled" class="mb-4">
            <div class="row mb-5 mt-4">
                <div class="col-md-12 darker font-weight-600">Time before event for automatic cancellation:</div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Direct - In person</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Phone</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Email</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

            <div class="row px-5 mb-3">
                <div class="col-sm-4">Website</div>
                <div class="col-sm-3 d-flex">
                    <input class="glued-right w-50 bg-lighter" type="number">
                    <v-select class="w-50" value="Minutes" :options="['Minutes', 'Hours']"></v-select>
                </div>
            </div>

        </div>

        <!-- Accodion ID 5 - Commissions | Disable -->
        <div v-if="accordions[4].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(4)">
            <span class="darker font-weight-600">Commissions</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[4].isOpen}"></i>
        </div>
        <div v-if="accordions[4].isOpen && accordions[4].enabled" class="mb-4">
            <div class="row px-5 mb-3 align-items-start">
                <div class="col-md-6 row">
                    <div class="col-md-12 darkest font-weight-600">Agents</div>

                    <div class="row m-0 align-items-center w-100">
                        <div class="col-md-8"></div>
                        <div class="col-md-4 dark font-weight-600 fs-small text-center">
                            Commission
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Products - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number" v-model="localPresets.commissionAgentsProduct">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Extras - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number" v-model="localPresets.commissionAgentsComponent">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Pickups - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number" v-model="localPresets.commissionAgentsTransport">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 row" >
                    <div class="col-md-12 darkest font-weight-600">My Team - Sellers</div>

                    <div class="row m-0 align-items-center w-100">
                        <div class="col-md-8"></div>
                        <div class="col-md-4 dark font-weight-600 fs-small text-center">
                            Commission
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Products - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number"  v-model="localPresets.commissionMyTeamProduct">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Extras - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number"  v-model="localPresets.commissionMyTeamComponent">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>

                    <div class="row m-0 mb-3 align-items-center w-100">
                        <div class="col-sm-8">
                            Pickups - Commission by default
                        </div>
                        <div class="col-sm-4 d-flex justify-content-center">
                            <input class="glued-right w-50 bg-lighter" type="number"  v-model="localPresets.commissionMyTeamTransport">
                            <div class="glued-left dark w-25">%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Accodion ID 6 - Discounts | Enable -->
        <div v-if="accordions[5].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(5)">
            <span class="darker font-weight-600">Discounts</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[5].isOpen}"></i>
        </div>
        <div v-if="accordions[5].isOpen && accordions[5].enabled" class="mb-4">
            <div class="col-md-7 row">
                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Exclude extras from discounts
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.excludeExtraFromDiscounts" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Accodion ID 7 - Agents Permissions | Disable -->
        <div v-if="accordions[6].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(6)">
            <span class="darker font-weight-600">Agents Permissions</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[6].isOpen}"></i>
        </div>
        <div v-if="accordions[6].isOpen && accordions[6].enabled" class="mb-4">
            <div class="col-md-7 row">
                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Agents have access to Extras
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.agentsHaveAccessExtras"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Agents have access to Pickups
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.agentsHaveAccessPickups"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Accodion ID 8 - Widget Permissions | Disable -->
        <div v-if="accordions[7].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(7)">
            <span class="darker font-weight-600">Widget Permissions</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[7].isOpen}"></i>
        </div>
        <div v-if="accordions[7].isOpen && accordions[7].enabled" class="mb-4">
            <div class="col-md-7 row">
                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Widget have access to Extras
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.widgetHaveAccessExtras"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Widget have access to Pickups
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.widgetHaveAccessPickups"  :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

            </div>

        </div>

        <!-- Accodion ID 9 - Sales | Enable -->
        <div v-if="accordions[8].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(8)">
            <span class="darker font-weight-600">Sales</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[8].isOpen}"></i>
        </div>
        <div v-if="accordions[8].isOpen && accordions[8].enabled" class="mb-4">
            <div class="row mb-4">
                <div class="col-md-6 d-flex justify-content-end">
                    <div class="d-flex align-items-center ml-3 w-100">
                        <label class="full darkest">
                        Charge total amount for product higher than &nbsp;
                        </label>
                        <div class="d-flex ml-2">
                            <input class="glued-right bg-lighter" style="width: 80px;" type="number" v-model.number="localPresets.chargeTotalAmount">
                            <div class="glued-left dark">€</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex ljustify-content-end">
                    <div class="col-sm-8">
                        Allow refund without code
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.allowRefundWithoutCode" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label class="full">
                    Price Rounding Behavior (configuration option for price adjustments):
                </label>
                <v-select 
                    :value="roundingBehaviorInit" 
                    :options="roundingBehaviourTypeOptions"
                    label="name"
                    @input="roundingBehaviorUpdateVal($event)">
                </v-select>
            </div>
        </div>

        <!-- Accodion ID 10 - Payment Link -->
        <div v-if="accordions[9].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(9)">
            <span class="darker font-weight-600">Payment Link</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[9].isOpen}"></i>
        </div>
        <div v-if="accordions[9].isOpen && accordions[9].enabled" class="mb-4">
            <div class="col-md-7 row">
                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        Receive a notification when the customer completes the payment
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.emailSettings.allowPaymentLink" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Accodion ID 11 - Automatic Emails | Enable -->
        <div v-if="accordions[10].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(10)">
            <span class="darker font-weight-600">Automatic emails</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[10].isOpen}"></i>
        </div>
        <div v-if="accordions[10].isOpen && accordions[10].enabled" class="mb-4">
            <div class="col-md-7 row">
                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        <span class="bold">Reminder email: </span>Send an email 24 hours before the experience.
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.emailSettings.allowPreEvent" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

                <div class="row m-0 mb-3 align-items-center w-100">
                    <div class="col-sm-8">
                        <span class="bold">Follow-Up Email: </span>Send an email 4 hours after the experience.
                    </div>
                    <div class="col-sm-4 d-flex justify-content-end">
                        <toggle-button class="mr-3" v-model="localPresets.emailSettings.allowPostEvent" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>

                <div class="row m-0 my-2 align-items-center w-100">
                    <button class="btn wide ml-3" @click="sendTestEmail">Send Test Email</button>
                </div>
            </div>
        </div>

		<!-- Accodion ID 12 - Segmentation | Enable -->
		<div v-if="accordions[11].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(11)">
            <span class="darker font-weight-600">Segmentation</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[11].isOpen}"></i>
        </div>
		<div v-if="accordions[11].isOpen && accordions[11].enabled" class="col-md-7 row mb-4">
			<div class="row m-0 mb-3 align-items-center w-100">
				<div class="col-sm-8">
					Origins are required in reservations
				</div>
				<div class="col-sm-4 d-flex justify-content-end">
					<toggle-button class="mr-3" v-model="localPresets.isOriginRequired" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
				</div>
			</div>
			<div class="row m-0 mb-3 align-items-center w-100">
				<div class="col-sm-8">
					Segments are required in reservations
				</div>
				<div class="col-sm-4 d-flex justify-content-end">
					<toggle-button class="mr-3" v-model="localPresets.isSegmentRequired" :value="true" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6 col-sm-12">
				<!-- Accodion ID 13 - Cancellation Reasons | Enable -->
				<div v-if="accordions[12].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(12)">
					<span class="darker font-weight-600">Cancellation Reasons</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[12].isOpen}"></i>
				</div>
				<div v-if="accordions[12].isOpen && accordions[12].enabled" class="col-md-12 row mb-4">
					<div class="row m-0 mb-3 align-items-center w-100">
						<div class="">
							<div class="my-4 initial-height">
								Here you can define Cancellation Reasons so you can choose them when canceling reservations or events.
							</div>
							<div v-if="getReasons.length < 1" class="text-center dark fs-large w-100">
								No items available
							</div>
							<div>
								<div class="col-sm-12 pl-0">
									<div v-if="getReasons.length > 0">
										<div v-for="(reasons, reasonType) in groupedReasons" :key="reasonType">
											<div class="my-2">{{ reasonGroupName(reasonType) }}</div>
                                            <div class="custom-fields mb-5">
                                                <div v-for="reason in reasons" :key="reason.id">
                                                    <div class="d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover">
                                                    <div class="darker bold">{{reason.description}}</div>
                                                    <div class="withHover">
                                                        <span class="lighter bg-dark radius-normal fs-small px-2 pointer" @click="editReason(reason)">Edit</span>
                                                        <i class="ico ico-delete fs-normal dark pointer ml-2" @click="clickTrashReason(reason)"></i>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
										</div>
									</div>
									<button class="btn wide mt-4" @click="addReason">Add Cancellation Reason</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6 col-sm-12">
				<!-- Accodion ID 14 - Custom Businesses Types | Enable -->
				<div v-if="accordions[13].enabled" class="pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3" @click="toggleAccordion(13)">
					<span class="darker font-weight-600">Custom Business Types</span> <i class="ico-arrow-bottom larger pointer color-6" :class="{'ico-arrow-top': accordions[13].isOpen}"></i>
				</div>
				<div v-if="accordions[13].isOpen && accordions[13].enabled" class="col-md-12 row mb-4">
					<div class="row m-0 mb-3 align-items-center w-100">
						<div class="w-100">
							<div class="my-4 initial-height">
								Here you can define your custom business types.
							</div>
							<div v-if="getCustomBusinessTypes.length < 1" class="text-center dark fs-large w-100">
								No items available
							</div>
							<div>
								<div class="col-sm-12 pl-0">
                                    <div v-if="getCustomBusinessTypes.length > 0" class="my-2">All</div>
									<div v-if="getCustomBusinessTypes.length > 0" class="custom-fields mb-5">
										<div v-for="customBusinessType in getCustomBusinessTypes" :key="customBusinessType.id">
											<div class="d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover">
												<div class="darker bold">{{customBusinessType.name}}</div>
												<div class="withHover">
													<span class="lighter bg-dark radius-normal fs-small px-2 pointer" @click="editCustomBusinessType(customBusinessType)">Edit</span>
													<i class="ico ico-delete fs-normal dark pointer ml-2" @click="clickTrashCustomBusinessType(customBusinessType)"></i>
												</div>
											</div>
										</div>
									</div>
									<button class="btn wide mt-4" @click="addCustomBusinessType">Add Custom Business Type</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import extendedVSelect from '@/extends/vue-select'
    import Timepicker from '@/tools/Timepicker'

    export default {
        data() {
            return {
                accordions: [
                    {
                        id: 1,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id: 2,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 3,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 4,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id: 5,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id: 6,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 7,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id: 8,
                        isOpen: true,
                        enabled: false
                    },
                    {
                        id: 9,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 10,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 11,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 12,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 13,
                        isOpen: true,
                        enabled: true
                    },
                    {
                        id: 14,
                        isOpen: true,
                        enabled: true
                    },
                ],
                paymentDepositType: null,
                depositType: null,
                agentsPaymentDepositType: null,
                agentsDepositType: null,
                paymentCancelTypeObject: null,
                roundingBehaviourTypeOptions: [
                    { id: 0, name: 'No rounding' },
                    { id: 1, name: 'Round to the nearest whole number' },
                    { id: 2, name: 'Round to 1 decimal place' }
                ],
                localPresets: JSON.parse(JSON.stringify(this.presets)),
                originalPresets: JSON.parse(JSON.stringify(this.presets)),
                hasUnsavedChanges: false,
            }
        },
        created() {
            const { depositType, paymentDepositType, agentsPaymentDepositType, agentsDepositType } = this.localPresets;

            if (paymentDepositType) this.getPaymentOptions();
            if (depositType) this.setCorrectDepositPosition();
            if (agentsPaymentDepositType || agentsDepositType) this.initAgentsSalesOptions();

            this.paymentCancelTypeObject = this.paymentCancelTypeOptions.find((cancelType) => cancelType.id === this.localPresets.defaultPaymentCancelationType);
        },
        computed: {
            ...mapGetters([
                'getDepositOptions',
                'getRequirePaymentOptions',
                'getReasons',
                'getReasonTypesOptions',
                'getPaymentCancelTypeOptions',
                'getCustomBusinessTypes',
            ]),
            groupedReasons() {
                const groupedReasons = {};
                
                this.getReasons.forEach((reason) => {
                    const type = reason.reasonType;
                    if (!groupedReasons[type]) {
                        groupedReasons[type] = [];
                    }
                    groupedReasons[type].push(reason);
                });

                return groupedReasons;
            },
            paymentCancelTypeOptions() {
                return this.getPaymentCancelTypeOptions;
            },
            roundingBehaviorInit() {
                const roundRuleTypeId = this.localPresets.roundRuleType;
                
                return this.roundingBehaviourTypeOptions.find((roundingType)=>{
                    if (roundingType.id === roundRuleTypeId) {
                        return roundingType.name;
                    }
                })
            }
        },
        methods:{
            ...mapActions([
                'saveSettingsPresets',
                'openModal',
                'setSelectedReason',
                'deleteReason',
                'setSelectedCustomBusinessType',
                'deleteCustomBusinessType',
            ]),
            initAgentsSalesOptions() {
                const requirePaymentOptions = this.getRequirePaymentOptions || [];
                const depositOptions = this.getDepositOptions || [];

                // Init agentsPaymentDepositType
                this.agentsPaymentDepositType = requirePaymentOptions.find(
                    option => option.id === this.localPresets.agentsPaymentDepositType
                ) || null;

                // Init agentsDepositType
                this.agentsDepositType = depositOptions.find(
                    option => option.id === this.localPresets.agentsDepositType
                ) || null;
            },
            roundingBehaviorUpdateVal(event) {
                this.localPresets.roundRuleType = event.id;
            },
            sendTestEmail(){
                this.openModal('SendTestEmail.vue');
            },
            addCustomBusinessType(){
                this.openModal('customBusinessTypes/createCustomBusinessType');
            },
            editCustomBusinessType(customBusinessType){
                this.setSelectedCustomBusinessType(customBusinessType);
                this.openModal('customBusinessTypes/editCustomBusinessType.vue');
            },
            clickTrashCustomBusinessType(customBusinessType) {
                const customBusinessTypeName = customBusinessType.name;

                this.$dialog.confirm(`
                    <div class="fs-larg font-weight-600 mb-4">Delete item?</div>
                    <div>You are about to delete the item "${customBusinessTypeName}", continue?</span></div>`
                ).then(() => {
                    this.deleteCustomBusinessType(customBusinessType);
                }).catch((error) => {
                    console.error(error);
                });
            },
            addReason(){
                this.openModal('cancellationReasons/createCancellationReason.vue');
            },
            editReason(reason){
                this.setSelectedReason(reason)
                this.openModal('cancellationReasons/editCancellationReason.vue');
            },
            clickTrashReason(reason) {
                const reasonName = reason.description;
                this.$dialog.confirm(`
                    <div class="fs-larg font-weight-600 mb-4">Delete item?</div>
                    <div>You are about to delete the item "${reasonName}", continue?</span></div>`
                ).then(() => {
                    this.deleteReason(reason);
                }).catch((error) => {
                    console.error(error);
                });
            },
            reasonGroupName(reasonType){
                return this.getReasonTypesOptions[reasonType].name;
            },
            toggleAccordion(index){
                this.accordions[index].isOpen ^= true;
            },
            save() {
                this.saveSettingsPresets(this.localPresets);
                this.originalPresets = JSON.parse(JSON.stringify(this.localPresets));
                this.$emit('update:presets', JSON.parse(JSON.stringify(this.localPresets)));
                this.$emit('dirty-changed', false);
                this.hasUnsavedChanges = false;
            },
            reset() {
                this.localPresets = JSON.parse(JSON.stringify(this.originalPresets));
                this.$emit('dirty-changed', false);
                this.hasUnsavedChanges = false;
            },
            getPaymentOptions() {
                for (let paymentDepositType of this.getRequirePaymentOptions) {
                    if (paymentDepositType.id == this.localPresets.paymentDepositType) {
                        this.paymentDepositType = paymentDepositType;
                    }
                }
            },
            setCorrectDepositPosition() {
                for (let depositType of this.getDepositOptions) {
                    if (depositType.id == this.localPresets.depositType) {
                        this.depositType = depositType;
                    }
                }
            },
            setTimeBeforeEvent(e) {
                this.localPresets.timeBeforeEvent = e + ":00";
            },
            setDepositType(e) {
                this.localPresets.depositType = e.id;
            },
            setPaymentDepositType(e) {
                this.localPresets.paymentDepositType = e.id;
            },
            setAgentDepositType(e) {
                this.localPresets.agentsDepositType = e.id;
            },
            setAgentPaymentDepositType(e) {
                this.localPresets.agentsPaymentDepositType = e.id;
            },
            setPaymentCancelType(paymentCancelType){
                this.localPresets.defaultPaymentCancelationType = paymentCancelType.id;
            },
            onTabPresetsDirtyChanged(isDirty) {
                this.hasUnsavedChanges = isDirty;
            },
        },
        props: ['presets'],
        components: {
            vSelect: extendedVSelect,
            Timepicker
        },
        watch: {
            localPresets: {
                handler() {
                    const isDirty = JSON.stringify(this.localPresets) !== JSON.stringify(this.originalPresets);
                    this.hasUnsavedChanges = isDirty;
                    this.$emit('dirty-changed', isDirty);
                },
                deep: true
            },
            presets: {
                handler(newVal) {
                    this.localPresets = JSON.parse(JSON.stringify(newVal));
                    this.originalPresets = JSON.parse(JSON.stringify(newVal));
                    this.$emit('dirty-changed', false);
                },
                deep: true
            }
        },
    }
</script>

<style lang="scss" scoped>
    .glued-left-min-width {
        min-width: 2.25rem;
    }

    .custom-fields {
        overflow: auto;
        max-height: 24.5rem;
    }

    .initial-height {
        min-height: 2.5rem;
    }
</style>



// WEBPACK FOOTER //
// TabPresets.vue?1b07fda0